// extracted by mini-css-extract-plugin
export default {"pList":"PropertyList_pList__4jfvs","pListItem":"PropertyList_pListItem__qlaEm","pListImg":"PropertyList_pListImg__6N--p","pListTitles":"PropertyList_pListTitles__dWuNR"};